import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BackofficeChat } from '../components/backoffice/BackofficeChat'

interface User {
  id: string
  email: string
  name: string
  role: string
  company_name?: string
}

export function Chat() {
  const navigate = useNavigate()
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    // Check if user is logged in
    const userStr = localStorage.getItem('user')
    if (!userStr) {
      navigate('/login')
      return
    }
    try {
      const userData = JSON.parse(userStr)
      setUser(userData)
    } catch (error) {
      console.error('Failed to parse user data:', error)
      navigate('/login')
    }
  }, [navigate])

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-3xl font-bold text-foreground mb-2">AI Assistant</h1>
        <p className="text-muted-foreground">
          Your personal AI assistant for navigating the securesight.ai platform
        </p>
      </div>

      {/* Chat Interface */}
      <BackofficeChat userRole={user.role} currentPage="/chat" />
    </div>
  )
}
